import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import { environment } from '../../environments/environment';
import {extractData} from './utils';
import {Field, IRawField, mapField} from './field';


@Injectable()
export class GlobalConstantsService {

  constructor(
    private http: Http
  ) { }

  getAll() {
    return this.http.get(`${environment.apiUrl}/admin/fields`)
      .map(extractData)
      .map((fields: IRawField[]) => {
        return fields.map((rawField: IRawField) => {
          return mapField(rawField);
        });
      });
  }

  save(field) {
    if (!field.value) {
      delete field.value;
    }
    if (field.id) {
      return this.http
        .put(`${environment.apiUrl}/admin/fields/${field.id}`, field)
        .map(this.extractData);
    } else {
      return this.http
        .post(`${environment.apiUrl}/admin/fields`, field)
        .map(this.extractData);
    }

  }

  delete(id) {
    return this.http.delete(`${environment.apiUrl}/admin/fields/${id}`)
      .map(this.extractData);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }
}

export function onlyKitLevelFields(fields: any) {

  return fields.filter((field: any) => {

    if (field.element_id == null && field.scope == 'kit') {
      return true;
    }

    return false;
  })
}


// WEBPACK FOOTER //
// ./src/app/services/global-constants.service.ts